import VideoPlayerR2 from "./r2/index.vue";
import VideoPlayerVimeo from "./vimeo/index.vue";
import VideoPlayerYoutube from "./youtube/index.vue";
import { chooseProvider, videoPlayerType } from "@/utils/videoSource";

export default {
  name: "video-player",
  components: { VideoPlayerR2, VideoPlayerVimeo, VideoPlayerYoutube },
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    // Course/LMS provider field (`r2` / `vimeo` / …). When `r2`, force the R2
    // player even if `src` is a host we do not yet pattern-match.
    videoProvider: {
      type: String,
      required: false,
      default: null,
    },
    // LMS material/video id — the resume key (`_dmvideo_<id>`) for the R2
    // player. Optional: consumers that don't pass it just lose resume.
    videoId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    isKeepInViewportMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    videoType() {
      if (
        chooseProvider({ src: this.videoUrl, provider: this.videoProvider }) ===
        "r2"
      ) {
        return "r2";
      }
      return videoPlayerType(this.videoUrl);
    },
  },
};
